import React, { useContext, useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { signInWithCustomToken } from "firebase/auth";
import { Select as AntSelect, Form, Input, InputNumber, Modal, Radio } from "antd";
import { RecaptchaVerifier } from "firebase/auth";
import OtpInput from "react-otp-input";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate,useLocation } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../api/http";
import { default as loginservices, default as loginServices } from "../../api/loginservices";
import userapiservice from "../../api/userapiservice";
import { GlobalContext } from "../../components/globalContext/GlobalContext";
import ToastComponent from "../../components/ToastCompoent/ToastComponent";
import countryData from "../../json/countries.json";
import { setUserProfile } from "../../Reducer/globalSlice";
import { setAccessToken, setAgeId, setProfID, setRefresh, updateAge, updateAgeName,setUserDetails } from "../../Reducer/localStorageSlice";
import { handleErrorMessage } from "../../utils/helper";
import firebaseAuth from "./firebase";
import LoginAgeRestriction from "./LoginAgeRestriction";
import "./LoginPage.scss";
import { inputFieldCharLimit } from "../../config";
import usePartnerName from "../../hooks/usePartnerName";

const RE_SEND_TIMER = 30
export default function LoginPage() {
  const { endUserDetails, setEndUserDetails } =
    useContext(GlobalContext);
  const dispatch = useDispatch();
  const localData = useSelector((state) => state?.localStorage)
  const { profID, ageID, } = localData
  const { formattedName: partner } = usePartnerName()
   const [form] = Form.useForm();

  const [partnerLogo, setPartnerLogo] = useState(null);
  const [phoneFormat, setPhoneFormat] = useState(false);
  const navigate = useNavigate();
   const location = useLocation();
     const from = location.state?.from || "/microsite";
  


  const [loading, setLoading] = useState(false);
  const auth = '';
  const [selectedCountry, setSelectedCountry] = useState({ value: '+44', label: 'United Kingdom (+44)' });
  const [, setOTPPage] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [phoneRegistered, setPhoneRegistered] = useState(true);
  const [phone, setPhone] = useState(null);
  const [email, setEmail] = useState(null);
  const [username, setUsername] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [sessionInfo, setSessionInfo] = useState(null);
  const [ageGroups, setAgeGroups] = useState([]);
  const [ageGroupData, setAgeGroupsData] = useState([]);
  const [selectedAgeGroupsData, setSelectedAgeGroupsData] = useState();
  const [age, setAge] = useState();
  const [prof, setProf] = useState();

  //OTP states
  const [otpValue, setOtpValue] = useState("");
  const [error, setError] = useState(false)

  const countryOptions = countryData.map((country) => ({
    value: country.dial_code,
    label: `${country.name} (${country.dial_code})`,
  }));
  const defaultUKOption = countryOptions.find(option => option.label === 'United Kingdom (+44)');

  // Set the default value to the UK option
  const defaultSelectedCountry = defaultUKOption ? defaultUKOption : null;
 
  const startTimer = () => {
    setSeconds(RE_SEND_TIMER)
  }

  useEffect(() => {
  if (seconds === 0) return;

  const interval = setInterval(() => {
    setSeconds((prev) => prev - 1);
  }, 1000);

  return () => clearInterval(interval);
}, [seconds]);

  const handleRegisterSubmit = async (values) => {
    const selectedCountryCode = selectedCountry.value;
    const phone = `${selectedCountryCode}${values.phoneNumber}`;
    setPhone(phone);
    setEmail(values.email);
    setUsername(values.userName);
    setAge(values.ageId);
    setProf(values.tagId);

    try {
      setLoading(true);
      const reCaptchaToken = await window.recaptchaVerifier.verify();
      localStorage.setItem("Phone Number", phone);
      const session = await postRequest(
        loginservices.getOtp(),
        {
          phoneNumber: phone,
          recaptchaToken: reCaptchaToken,
          email: values.email,
          userName: values.userName,
          ageId: values.ageId,
          tagId: values.tagId,
        },
        auth
      );
      setShowLogin(false);
      setOTPPage(true);
      setSessionInfo(session.sessionInfo);
      startTimer();
    } catch (e) {
      Modal.error({
        title: "Error",
        content:
          e?.response?.data?.error ||
          "Something went wrong, please try again later.",
      });
      setLoading(false);
    }
  };

  const handleLoginSubmit = async (values) => {
    const checkPhone = await getRequest(
      userapiservice.checkPhonenumber(
        `${selectedCountry.value.replace(/\+/g, "%2B")}${values.phoneNumber}`
      )
    );
    if (checkPhone) {
      const selectedCountryCode = selectedCountry.value;
      const phone = `${selectedCountryCode}${values?.phoneNumber}`;
      setPhone(phone);

      try {
        setLoading(true);
        const reCaptchaToken = await window.recaptchaVerifier.verify();
        localStorage.setItem("Phone Number", phone);
        const session = await postRequest(
          loginservices.getOtp(),
          {
            phoneNumber: phone,
            recaptchaToken: reCaptchaToken,
          },
          auth
        );
        setShowLogin(false);
        setOTPPage(true);
        setSessionInfo(session.sessionInfo);
        startTimer();
      } catch (e) {
        toast.error(e?.response?.data?.message)
        console.error(e);
        setLoading(false);
      }
    } else {
      setPhoneRegistered(false);
    }
  };

  const getProfilePic = async (accessToken) => {
    try {
      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };
      const response = await getRequest(
        userapiservice.getEndUserDetails(),
        headers
      );

      if (response) {
        dispatch(setUserProfile(response))
        dispatch(setUserDetails(response))
      }
    } catch (error) {
      toast.error(<ToastComponent type={'Error'} message={handleErrorMessage(error, "Failed to fetch user profile")} />)
    }
  }

  const handleSubmit = async () => {
    try {
      let data = {};
      setLoading(true);
      if (email && username) {
        data = {
          sessionInfo: sessionInfo,
          phoneNumber: phone,
          code: otpValue,
          email: email,
          userName: username,
          ageId: age,
          tagId: prof,
        };
      } else {
        data = {
          sessionInfo: sessionInfo,
          phoneNumber: phone,
          code: otpValue,
        };
      }
      const response = await postRequest(loginServices.studentLogin(), data);
      if (response) {
       const AGEname =

          ageGroups?.find((ageGroup) => ageGroup.id === age)?.ageGroup || "";
        setLocalAge(AGEname, age);
        if (!profID) {
          dispatch(setProfID(prof))
        }
        try {
          const customToken = response?.customToken
          const userCredential = await signInWithCustomToken(firebaseAuth, customToken);
          const user = userCredential?.user;
          const idToken = await user?.getIdToken(true); // fetch latest
          const refreshToken = user?.refreshToken;
          dispatch(setAccessToken(idToken))
          dispatch(setRefresh(refreshToken))
          // Optionally, send this ID token with API requests
          localStorage.setItem("firebaseIdToken", idToken);
        } catch (error) {
          console.error("Firebase sign-in failed:", error);
        }


    
        getProfilePic(response?.accessToken)
        toast.success(<ToastComponent type={'Success'} message={'Successfully logged in!'} />)


        try {
          const updatedDetails = {
            ...endUserDetails,
            endUserDetailsInput: {
              ...endUserDetails.endUserDetailsInput,
              tagId: profID,
              ageId: ageID,

            },
          };

          setEndUserDetails(updatedDetails);

          const formData = new FormData();
          const endUserDetailsInputBlob = new Blob(
            [JSON.stringify(updatedDetails.endUserDetailsInput)],
            { type: "application/json" }
          );
          formData.append("endUserDetailsInput", endUserDetailsInputBlob);

        } catch (updateError) {
          console.error("Error updating end user details:", updateError);
        }

        if (!response.accessToken) {
          localStorage.removeItem("Phone Number");
        }
        navigate(from, { replace: true });
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
      setError(true);
    }
  };

  const getPartnerLogo = async () => {
    if(!partner) return
    try {
      const response = await getRequest(
        userapiservice.getPartnerDetails(partner)
      );
      setPartnerLogo(response);
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  useEffect(() => {
if(form) {
  form.setFieldsValue({
    tagId: profID || selectedAgeGroupsData || ""
  })
}
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[profID,form])


  useEffect(() => {
    getPartnerLogo();
    window.recaptchaVerifier = new RecaptchaVerifier(
      "recaptcha",
      {
        size: "invisible",
        callback: (response) => {
          return response;
        },
      },
      firebaseAuth
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partner]);

  const getAgeGroups = async () => {
    try {
      const response = await getRequest(userapiservice.getEndUserAgeGroups());
      setAgeGroups(response);
    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };

  const getAgeData = async (value) => {
    try {
      const response = await getRequest(userapiservice.getWhatDoYouDo(value));
      if (response) {
        setAgeGroupsData(response);
      }


    } catch (e) {
      Modal.error({
        title: "Error",
        content: e.response?.data?.message || "Something went wrong...",
      });
    }
  };



  useEffect(() => {
    getAgeGroups();
    if (ageID) {
      getAgeData(ageID);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ageID]);

  const setLocalAge = (value, id) => {
    if (value === "< 18") {
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
      dispatch(updateAge("18"))
    } else if (value === "19 - 23") {
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
      dispatch(updateAge("23"))
    } else if (value === "24 - 37") {
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
      dispatch(updateAge("37"))
    } else if (value === "38 - 53") {
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
      dispatch(updateAge("53"))
    } else if (value === "54+") {
      dispatch(setAgeId(id))
      dispatch(updateAgeName(value))
      dispatch(updateAge("53"))
    }
  };

  const resendOtpHandler = async() => {
    const reCaptchaToken = await window.recaptchaVerifier.verify();
    try {
      await postRequest(
      loginservices.getOtp(),
      {
        phoneNumber: phone,
        recaptchaToken: reCaptchaToken,
      },
      auth
    );
    toast.success('OTP has been sent successfully')
    startTimer()
    } catch (e){
      toast.error(e?.response?.data?.message)
    }
    
  }

  return (
    <div className="login-wrapper bg-white ">
      <LoginAgeRestriction />
      <div className="login-card-container">
        <h3 className="login-welcome">Welcome</h3>
        <div className="logo">
          {partnerLogo?.mediaLink && (
            <img src={partnerLogo?.mediaLink} width={206} alt="Partner Logo" />
          )}
        </div>
        {showLogin ? (
          phoneRegistered ? (
            <div className="inputContainer">
              <div className="textInput">
                <Form
                form={form}
                  name="userRegistrationForm"
                  onFinish={handleLoginSubmit}
                  requiredMark={false}
                  autoComplete="off"
                  className="form-container"
                  initialValues={{ phoneNumber: '' ,
                    tagId: profID || selectedAgeGroupsData 
                  }}
                >
                  <div className="ant-form-item">
                    <Select
                      className="user-registration-select"
                      classNamePrefix="user-registration-select"
                      value={selectedCountry || defaultSelectedCountry}
                      onChange={(value) => setSelectedCountry(value)}
                      options={countryOptions}
                      placeholder="Select Country"
                    />
                  </div>
                  <Form.Item
                    name="phoneNumber"
                    validateFirst={true}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your Mobile number!",
                      },
                      {
                        validator(_, value) {
                          if (value.toString().length <= 12)
                            return Promise.resolve();
                          return Promise.reject(
                            new Error("Invalid mobile number")
                          );
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      controls={false}
                      style={{ width: "100%" }}
                      placeholder="Mobile number"
                      parser={(value) => (value ? value.toString().replace(/\D/g, "").slice(0, 12) : "")}
                      formatter={(v) => (v === undefined || v === null ? "" : String(v))}
                      onChange={(value) => {
                        const digits = (value || "").toString().replace(/\D/g, "").slice(0, 12);
                        // keep form value in sync (form exists in this component)
                        if (form && form.setFieldsValue) {
                          form.setFieldsValue({ phoneNumber: digits });
                        }
                        setPhoneFormat(true);
                      }}
                      onPaste={(e) => {
                        const pasted = (e.clipboardData || window.clipboardData).getData("text");
                        if (/\D/.test(pasted)) {
                          e.preventDefault();
                          const digits = pasted.replace(/\D/g, "").slice(0, 12);
                          if (form && form.setFieldsValue) form.setFieldsValue({ phoneNumber: digits });
                          setPhoneFormat(true);
                        }
                      }}
                      onKeyDown={(e) => {
                        const allowed = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
                        if (allowed.includes(e.key)) return;
                        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
                        // also block input if already 12 digits
                        const current = (e.target?.value || "").toString().replace(/\D/g, "");
                        if (/^[0-9]$/.test(e.key) && current.length >= 12) e.preventDefault();
                      }}
                      stringMode
                    />

                  </Form.Item>
                  {phoneFormat ? (
                    <p style={{ marginTop: "-20px", color: "grey" }}>
                      Use the format "7012341234" without prefixing 0
                    </p>
                  ) : (
                    ""
                  )}
                  <div className="d-flex justify-content-center">
                    <button
                      id="submit-btn"
                      type="submit"
                      disabled={loading || localData?.age === "18"}
                      className="btn btn-danger form-submit-btn get-opt-btn d-flex justify-content-center align-items-center "
                    >

                      {loading && (
                        <LoadingOutlined style={{ color: "white", padding: '5px' }} />
                      )}
                      <span>Next</span>
                    </button>
                  </div>
                  <div
                    style={{
                      textAlign: "center",
                      marginTop: "10px",
                      marginBottom: "0px",
                      fontSize: "14px",
                      color: "#333",
                    }}
                  >
                    {"< 18 years users need not login"}
                  </div>

                </Form>
              </div>
            </div>
          ) : (
            <div className="inputContainer">
              <div className="textInput">
                <Form
                  name="userRegistrationForm"
                  onFinish={handleRegisterSubmit}
                  requiredMark={false}
                  autoComplete="off"
                  className="form-container"
                  // initialValues={{ tagId: '84bcba67-5ef2-4e77-bdc2-dafc38d79e3b' }}
                >
                  <div className="ant-form-item">
                    <Select
                      className="user-registration-select"
                      classNamePrefix="user-registration-select"
                      value={selectedCountry || defaultSelectedCountry}
                      onChange={(value) => setSelectedCountry(value)}
                      options={countryOptions}
                      placeholder="Select Country"
                    />
                  </div>
                  <Form.Item
                    name="phoneNumber"
                    validateFirst={true}
                    rules={[
                      {
                        required: true,
                        message: "Please enter your Mobile number!",
                      },
                      {
                        validator(_, value) {
                          if (value.toString().length <= 12)
                            return Promise.resolve();
                          return Promise.reject(
                            new Error("Invalid mobile number")
                          );
                        },
                      },
                    ]}
                  >
                    <InputNumber
                      onChange={() => {
                        setPhoneFormat(true);
                      }}
                      maxLength={12}
                      min={0}
                      style={{ width: "100%" }}
                      placeholder="Mobile number"
                      className=" "
                    />
                  </Form.Item>
                  {phoneFormat ? (
                    <p className="phoneFormat">
                      Use the format "7012341234" without prefixing 0                    </p>
                  ) : (
                    ""
                  )}
                  <Form.Item
                    name="email"
                    normalize={(value) => value?.trim()}
                    validateFirst={true}
                    rules={[
                      { required: true, message: "Email is required" },
                      { type: "email", message: "Enter valid email" },
                    ]}
                  >
                    <Input placeholder="Email" maxLength={inputFieldCharLimit} className=" " />
                  </Form.Item>
                  <Form.Item
                    name="userName"
                    validateFirst={true}
                    rules={[
                      { required: true, message: "Username is required" },
                    ]}
                  >
                    <Input placeholder="Name" maxLength={inputFieldCharLimit} className=" " />
                  </Form.Item>
                  <Form.Item
                    colon={false}
                    className="age-form"
                    initialValue={
                      ageID
                        ? ageID
                        : ""


                    }
                    rules={[{ required: true, message: "Age is required" }]}
                    name="ageId"
                  >
                    <Radio.Group
                      className="age-radio"
                      buttonStyle="solid"

                    >
                      {ageGroups && ageGroups.length > 0
                        ? ageGroups.slice(1).map((ageGroup) => (
                          <Radio.Button
                            value={ageGroup?.id}
                            onClick={() => {
                              getAgeData(ageGroup?.id);
                              setSelectedAgeGroupsData(null);
                              setLocalAge(ageGroup?.value, ageGroup?.id);
                            }}
                            onChange={() => {
                              setSelectedAgeGroupsData("");
                            }}
                            style={{ display: 'flex', justifyContent: 'center', minWidth: '25px', whiteSpace: 'nowrap', margin: "0 2px" }}
                          >
                            {ageGroup?.value}
                          </Radio.Button>
                        ))
                        : ""}
                    </Radio.Group>
                  </Form.Item>
                  <Form.Item
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "What do you do? is required",
                      },
                    ]}
                    labelCol={{ span: window.innerWidth > 380 ? 4 : 7 }}
                    name="tagId"
                  >
                    <AntSelect
                      className=" "
                      value={selectedAgeGroupsData || ''}
                      placeholder="What do you do?"
                      onChange={(e) => {
                        console.log('e', e)
                        setSelectedAgeGroupsData(e)
                      }}
                    >
                      {ageGroupData &&
                        ageGroupData?.map((ageGroupData) => (
                          <AntSelect.Option
                            key={ageGroupData?.value}
                            value={ageGroupData?.id}
                          >
                            {ageGroupData?.value}
                          </AntSelect.Option>
                        ))}
                    </AntSelect>
                  </Form.Item>
                  <div className="d-flex justify-content-center">
                    <button
                      id="submit-btn"
                      type="submit"
                      disabled={loading}
                      className="btn btn-danger form-submit-btn get-opt-btn d-flex justify-content-center align-items-center "
                    >

                      {loading && (
                        <LoadingOutlined style={{ color: "white", padding: '5px' }} />
                      )}
                      <span>Next</span>
                    </button>
                  </div>
                </Form>
              </div>
            </div>
          )
        ) : (
          <div className="inputContainer">
            <div className="verify-heading">
              <p className="regular-text">{`Please enter the One Time Password(OTP) sent to ${phone} `}</p>
            </div>
            {error && (
              <div className="verify-error">
                <div style={{ padding: "0.5em" }}>
                  Authentication Failed! Please Retry
                </div>
              </div>
            )}
            <div className="verify-input">
              <div className="OTP-form">
                <OtpInput
                  className="otpFields"
                  shouldAutoFocus={true}
                  value={otpValue}
                  onChange={setOtpValue}
                  numInputs={6}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                />
              </div>

              <button
                className="btn btn-danger get-opt-btn verify-now-btn "
                type="button"
                onClick={() => handleSubmit()}
              >
                Verify Now
              </button>
              <div className="resend-otp-wrapper regular-text d-flex gap-2 justify-content-end">
                <div className={`resend-otp ${seconds ? 'inactive-ro' : ''}`} onClick={resendOtpHandler}>Resend OTP</div> 
                {!!seconds && <div>in {seconds} sec</div>}
              </div>
            </div>

          </div>
        )}

        <div className="spacer"></div>
        <div id="recaptcha" style={{ display: "none" }}></div>
      </div>
    </div>
  );
}
